class NumberUtils {

    public static between = (value: number, min: number, max: number): boolean => value > min && value < max;
}
export default NumberUtils;